module.exports = __webpack_public_path__ + "static/media/add_circle.c76e964d.svg";